import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';

var speedSwitch = function speedSwitch(speed) {
  if (speed === 'fast') return 600;
  if (speed === 'slow') return 900;
  return 750;
};

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "title"
}, "Circle loading spinner");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "desc"
}, 'Image of a partial circle indicating "loading."');

function Spinner(_ref) {
  var color = _ref.color,
      gap = _ref.gap,
      size = _ref.size,
      speed = _ref.speed,
      thickness = _ref.thickness,
      other = _objectWithoutProperties(_ref, ["color", "gap", "size", "speed", "thickness"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "loader-spinner",
    height: size,
    width: size
  }, other, {
    style: {
      animationDuration: "".concat(speedSwitch(speed), "ms")
    },
    className: "__react-svg-spinner_circle",
    role: "img",
    "aria-labelledby": "title desc",
    viewBox: "0 0 32 32"
  }), _ref2, _ref3, /*#__PURE__*/React.createElement("style", {
    // eslint-disable-next-line
    dangerouslySetInnerHTML: {
      __html: "\n          .__react-svg-spinner_circle{\n              transition-property: transform;\n              animation-name: __react-svg-spinner_infinite-spin;\n              animation-iteration-count: infinite;\n              animation-timing-function: linear;\n          }\n          @keyframes __react-svg-spinner_infinite-spin {\n              from {transform: rotate(0deg)}\n              to {transform: rotate(360deg)}\n          }"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    role: "presentation",
    cx: 16,
    cy: 16,
    r: 14 - thickness / 2,
    stroke: color,
    fill: "none",
    strokeWidth: thickness,
    strokeDasharray: Math.PI * 2 * (11 - gap),
    strokeLinecap: "round"
  }));
}

process.env.NODE_ENV !== "production" ? Spinner.propTypes = {
  /**
   * CSS color
   */
  color: PropTypes.string,

  /**
   * Size of the gap in spinner circle
   */
  gap: PropTypes.oneOf([1, 2, 3, 4, 5]),

  /**
   * Spinner size in `px`.
   */
  size: PropTypes.number,

  /**
   * Rotation speed.
   */
  speed: PropTypes.oneOf(['normal', 'fast', 'slow']),

  /**
   * Thickness of spinner circle
   */
  thickness: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8])
} : void 0;
Spinner.defaultProps = {
  color: 'rgba(0,0,0,0.4)',
  gap: 4,
  size: 40,
  speed: 'normal',
  thickness: 3
};
export default Spinner;